import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const HeroSection: React.FC = () => {
  return (
    <section className="relative h-screen flex items-center overflow-hidden">
      {/* Background Video with Overlay */}
      <div className="absolute inset-0 z-0">
        <video
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          className="w-full h-full object-cover"
          style={{ filter: 'brightness(0.9) contrast(1.05)' }}
        >
          <source src="/assets/videos/drone.MP4" type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 to-black/60"></div>
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl"
        >
          <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
            <span className="text-primary-light">Protégeons</span> votre maison avec excellence
          </h1>
          
          <p className="font-heading text-xl md:text-2xl text-gray-200 mb-8 leading-relaxed">
            Expertise, qualité et innovation au service de vos projets de couverture et étanchéité depuis plus de 15 ans.
          </p>
          
          <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
            <Link 
              to="/services" 
              className="bg-primary hover:bg-primary-dark text-white font-heading font-medium py-3 px-8 rounded-md transition-colors duration-300 text-center"
            >
              Nos services
            </Link>
            <Link 
              to="/contact" 
              className="bg-transparent hover:bg-white/10 text-white border-2 border-white font-heading font-medium py-3 px-8 rounded-md transition-colors duration-300 text-center"
            >
              Contactez-nous
            </Link>
          </div>
        </motion.div>
      </div>

      {/* Decorative Elements */}
      <motion.div 
        className="absolute bottom-0 right-0 w-1/3 h-1/3 bg-primary opacity-20 rounded-tl-full"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 0.2, scale: 1 }}
        transition={{ duration: 1.2, delay: 0.5 }}
      />
      
      <motion.div 
        className="absolute -bottom-10 -left-10 w-40 h-40 bg-secondary opacity-20 rounded-full"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 0.2, scale: 1 }}
        transition={{ duration: 1.2, delay: 0.7 }}
      />
    </section>
  );
};

export default HeroSection;
